import { Component, OnInit, Optional } from "@angular/core";
import { AuthService } from "../../providers/auth.service";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { TrackingService } from "../../providers/tracking.service";
import { CookieService } from "ngx-cookie-service";
import { BvDialogRef } from "../../design-system";
import { RoutingService } from "../../providers/routing.service";

import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { BvCheckboxComponent } from "../../design-system/primitives/checkbox.component";
import { FormsModule } from "@angular/forms";
import { BvFormFieldComponent } from "../../design-system/primitives/form-field.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-signup",
    templateUrl: "./signup.component.html",
    styleUrls: ["./signup.component.scss"],
    animations: [
        trigger('tdCollapse', [
            // overflow:hidden is on BOTH states so it stays static (clipping the
            // content while height animates) instead of being diffed into the
            // transition — animating overflow isn't allowed and logs a warning.
            state('true', style({ height: '0', overflow: 'hidden' })),
            state('false', style({ height: '*', overflow: 'hidden' })),
            transition('true <=> false', animate('{{duration}}ms ease-in-out'), { params: { duration: 200 } })
        ])
    ],
    imports: [BvDialogTitleComponent, BvDialogBodyComponent, BvButtonComponent, BvCheckboxComponent, FormsModule, BvFormFieldComponent, BvInputDirective, BvDialogFooterComponent, TranslateModule]
})
export class SignupComponent implements OnInit {
  collapseTrigger: boolean = true;
  topTrigger: boolean = false;
  createEmail!: string;
  createPassword!: string;
  acceptNewsletter: boolean = true;
  constructor(
    public auth: AuthService,
    private tracking: TrackingService,
    private cookieService: CookieService,
    private routing: RoutingService,
    @Optional() private dialogRef: BvDialogRef<SignupComponent>
  ) {}

  ngOnInit() {
    // If successful signup and we're on standalone page, let connection router handle routing
    if (!this.dialogRef) {
      this.auth.user.subscribe(user => {
        if (user) {
          // Only redirect to lobby if no alternate route is set
          if (!this.auth.altRoute) {
            this.routing.toLobby();
          }
          // Otherwise, let the connection router handle the routing
        }
      });
    }
  }
  socialLogin(provider: string) {
    this.cookieService.set(
      "refuseNewsletter",
      this.acceptNewsletter ? "false" : "true"
    );
    if (this.auth.engageParams)
      this.tracking.homeEngage(2, provider + "_login");
    this.auth.socialLogin(provider);
  }
  createEmailPassword() {
    this.cookieService.set(
      "refuseNewsletter",
      this.acceptNewsletter ? "false" : "true"
    );
    if (this.auth.engageParams) this.tracking.homeEngage(2, "email_login");
    this.auth.createEmail(this.createEmail, this.createPassword);
  }
  toggleCollapse() {
    this.collapseTrigger = !this.collapseTrigger;
    this.topTrigger = !this.topTrigger;
  }
}
